import React, { useEffect, useState } from "react";
import Sectitle from "../Title/Sectitle";
import Teamitem from "../Team/Teamitem";
import lang from "../../lang/lang";
import { getPodcasts } from "../../services/api";
import { useNavigate } from "react-router-dom";
const PodastdataBookDetail = () => {
  const [books, setBooks] = useState([])
  const Lange = localStorage.getItem('lang')

  useEffect(() => {
    const random = () => getPodcasts().then(function(response) {
      setBooks(response.data)
      console.log(response.data);
    })

    random()
  }, [])

  const navigate = useNavigate();

  if (typeof books === 'undefined') {
    return(
      <h1>Loading...</h1>
    )
  } 
  console.log(lang);
  return (
    <section className="experts_team_area sec_pad" style={{marginTop:"50px"}}>
      <div className="container">
        <Sectitle
          sClass="sec_title text-center mb_70"
          Title={lang.S_POSCAST}
          tClass="t_color3"
          TitleP=""
        />
        <div className="row">
        {books && books.map((book, key) => (
              <div className="col-lg-4 col-sm-6" onClick={() => {navigate(`/podcast/${book._id}`)}}>
                <Teamitem
                  teamImage={`https://api.resto.oryxintl.co:3000/${book.image}`}
                  memberN={Lange === "ENGLISH" ? book.name : book.arname}
                />
              </div>
            ))}

          {/* <div className="col-lg-4 col-sm-6">
                        <Teamitem teamImage="team_8.jpg" memberN="Bailey Wonger" memberd="Marketer"/>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <Teamitem teamImage="team_9.jpg" memberN="Max Conversion" memberd="Social Marketer"/>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <Teamitem teamImage="team_10.jpg" memberN="Jake Weary" memberd="UI/UX designer"/>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <Teamitem teamImage="team_9.jpg" memberN="Justin Case" memberd="Marketer"/>
                    </div>
                    <div className="col-lg-3 col-sm-6">
                        <Teamitem teamImage="team_12.jpg" memberN="Norman Gordon" memberd="Web developer"/>
                    </div> */}
        </div>
      </div>
    </section>
  );
};
export default PodastdataBookDetail;
